import { Clock, Spacer } from '@sparemin/blockhead';
import dayjs from 'dayjs';
import React, { useMemo } from 'react';
import { useFileArchiveInfo, useReprAt } from './ProjectPreviewModalContext';

export interface ProjectPreviewModalHeadingSubtitleProps {}

const ProjectPreviewModalHeadingSubtitle: React.FC<ProjectPreviewModalHeadingSubtitleProps> = () => {
  const reprAt = useReprAt();
  const {
    isFileArchived,
    isRestoreInProgress,
    restoreExpiresAt,
  } = useFileArchiveInfo();

  const formattedReprAt = useMemo(
    (): string => dayjs(reprAt).format('MMM D, YYYY'),
    [reprAt],
  );
  const formattedRestoreExpiresAt = useMemo(
    (): string => dayjs(restoreExpiresAt).format('MMM D, YYYY'),
    [restoreExpiresAt],
  );

  if (isFileArchived) {
    return <span>archived</span>;
  }

  if (isRestoreInProgress) {
    return (
      <Spacer
        space="10px"
        orientation="horizontal"
        align="center"
        justify="center"
      >
        <Clock />
        <span>restoring...</span>
      </Spacer>
    );
  }

  if (restoreExpiresAt) {
    return <span>`restored until ${formattedRestoreExpiresAt}`</span>;
  }

  return <span>{formattedReprAt}</span>;
};

export default ProjectPreviewModalHeadingSubtitle;
